import React from 'react';
import { Flex, Title, Text } from '@mantine/core';

interface ModalDataTextProps {
  value: string | number;
  title: string;
  accessorKey: string;
  disabled?: boolean;
}

export const ModalDataText: React.FC<ModalDataTextProps> = ({
  value,
  title,
  accessorKey,
  disabled = false,
}) => {
  return (
    <React.Fragment key={accessorKey}>
      <Flex align={'center'} gap={'xs'} direction={'column'}>
        <Title order={6}>{title}</Title>
        <Text
          size="lg"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          variant="outline"
          opacity={disabled ? 0.5 : 1}
        >
          {value}
        </Text>
      </Flex>
    </React.Fragment>
  );
};
